// src/components/scrollup/ScrollUp.jsx
import React, { useEffect } from "react";
import "./scrollup.css";

const ScrollUp = () => {
    useEffect(() => {
        const handleScroll = () => {
            const scrollUp = document.querySelector(".scrollup");
            // Add null check here
            if (!scrollUp) return;
            
            // When the scroll is higher than 560 viewport height, add the show-scroll class
            if (window.scrollY >= 560) {
                scrollUp.classList.add("show-scroll");
            } else {
                scrollUp.classList.remove("show-scroll");
            }
        };

        window.addEventListener("scroll", handleScroll);
        
        // Cleanup
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <a href="#" className="scrollup" onClick={(e) => {
            e.preventDefault();
            scrollToTop();
        }}>
            <i className="uil uil-arrow-up scrollup__icon"></i>
        </a>
    );
};

export default ScrollUp;